export const INTRO_SEEN_STORAGE_KEY = "introSeen";

